import React from 'react';

// Importation des différents composants
import ErrorLink from '../components/Fonctions/ErrorLink';

const Home = () => {
    return (
        <div>
            <ErrorLink />
        </div>
    );
};

export default Home;